import { finalize } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { OfferService } from 'src/app/services/offer.service';
import { GeneralService } from 'src/app/services/general.service';
import { OfferModel, ProductModel } from './../../models/wardrobe.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { OFFER_TYPE_PRICE_DISCOUNT } from 'src/app/constants/general.constant';
import { OfferSuccessModalComponent } from '../offer-success-modal/offer-success-modal.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'shc-price-discount-modal',
  templateUrl: './price-discount-modal.component.html',
  styleUrls: ['./price-discount-modal.component.scss'],
})
export class PriceDiscountModalComponent implements OnInit {
  price: number;
  userId: number;
  form: UntypedFormGroup;
  offer: OfferModel;
  @Input() senderId: number;
  optionalPrices: Array<number>;
  @Input() product: ProductModel;

  constructor(
    private modalCtrl: ModalController,
    private userService: UserService,
    private errorService: ErrorHandlerService,
    private translate: TranslateService,
    private offerService: OfferService,
    private generalService: GeneralService,
  ) { }

  ngOnInit() {
    this.userService.get().subscribe(res => {
      this.userId = res.id;
    });
    this.form = new UntypedFormGroup({
      product_id: new UntypedFormControl(this.product?.id || null),
      sent_by: new UntypedFormControl(this.product?.user?.id || null),
      sent_to: new UntypedFormControl(this.senderId),
      offer_type: new UntypedFormControl(OFFER_TYPE_PRICE_DISCOUNT),
      original_price: new UntypedFormControl(this.product?.price || null),
      offered_price: new UntypedFormControl(this.product?.price || null),
      offer_description: new UntypedFormControl(null),
      offered_product_id: new UntypedFormControl(this.product?.id)
    });
    this.price = this.product.price;
    // this.optionalPrices = [];
    // while (this.optionalPrices.length < 4) {
    //   const r = Math.floor(Math.random() * this.product.price) + 1;
    //   if (this.optionalPrices.indexOf(r) === -1) {
    //     this.optionalPrices.push(r);
    //   }
    // }
    // this.optionalPrices = this.optionalPrices.sort((a, b) => {
    //   return a - b;
    // });
  }

  priceChanged(ev: any) {
    this.price = ev.target.value;
  }

  incrementPrice() {
    this.price++;
  }

  decrementPrice() {
    if (this.price > 1) {
      this.price--;
    } else {
      this.errorService.showToast(this.translate.instant(marker('Price.Error')));
    }
  }

  offerDiscount() {
    this.form.patchValue({
      sent_by: this.userId,
      offered_price: this.price
    });
    this.generalService.showLoader();
    this.offerService.createOffer(this.form.value).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      this.offer = res;
      this.successModal();
    }, error => {
      this.errorService.handle(error);
    });
  }

  async successModal() {
    const modal = await this.modalCtrl.create({
      component: OfferSuccessModalComponent,
      cssClass: 'offer-success-modal',
      canDismiss: true,
      id: 'offerSuccess'
    });
    modal.onDidDismiss().then((data) => {
      console.log(this.offer);
      this.modalCtrl.dismiss(this.offer, null, 'priceDiscount');
    });
    return await modal.present();
  }

  closeModal() {
    this.modalCtrl.dismiss(null, null, 'priceDiscount');
  }

}
